
import { Component, Prop, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'

@Component
export default class SelectWorkingZone extends AbpBase {
  name: string = 'SelectWorkingZone'

  @Prop({ type: Boolean, default: false }) visible: boolean

  /**
   * true  = 登入強制選店：無 X、ESC、點外關閉，只有 Confirm 能離開
   * false = Change Store：可自由關閉
   */
  @Prop({ type: Boolean, default: false }) mandatory: boolean

  selected: any = null

  get loading(): boolean {
    return this.$store.state.userworkingzone.loading
  }

  /**
   * dropdown 選項。label 沿用專案慣例 "WorkingZone-Name"
   */
  get zoneList(): Array<any> {
    return (this.$store.state.userworkingzone.myZones || []).map(t => {
      return {
        label: t.name ? `${t.workingZone}-${t.name}` : t.workingZone,
        value: t.id,
        workingZone: t.workingZone
      }
    })
  }

  @Watch('visible')
  async onVisibleChange(val: boolean) {
    if (!val) {
      return
    }
    this.selected = null
    await this.$store.dispatch({ type: 'userworkingzone/getMyZones' })

    // 目前生效的 zone 若在清單中，預設選它，減少切換成本
    const currentId = this.$store.state.workzone.workZoneId
    if (currentId && this.zoneList.some(z => z.value === currentId)) {
      this.selected = currentId
    }
  }

  handleClose() {
    if (this.mandatory) {
      return
    }
    this.$emit('update:visible', false)
  }

  doConfirm() {
    const picked = this.zoneList.find(z => z.value === this.selected)
    if (!picked) {
      return
    }

    // ⚠️ workZone 必須存「代碼字串」（ALL、0014），不是 Id。
    // mixins/workzone.js 與 35 個列表／報表畫面都是拿它跟 'ALL' 做字串比較，
    // 存 Id 會靜默破壞全部 zone 篩選。
    this.$store.commit('workzone/updateWorkZone', {
      workZone: picked.workingZone,
      workZoneId: picked.value
    })

    sessionStorage.setItem('workingZoneConfirmed', '1')
    this.$emit('update:visible', false)

    // keep-alive 會快取已開啟的頁面組件（baseLayout 的 <keep-alive>），
    // 不重整的話被快取的畫面不會重新查詢，仍顯示舊 zone 的資料
    location.reload()
  }
}
